import React from 'react';
import {ConsentContext} from "./OneTrustWrapper";

class OneTrustLoader extends React.Component {

  groupsLoadGtm = ['C0002','V2STACK42'] // gruppenIds bei denen der tagmanager geladen werden soll
  gtmId = 'GTM-5L9337Z';

  static contextType = ConsentContext;

  componentDidMount() {
    this.checkConsent();
  }

  componentDidUpdate() {
    this.checkConsent();
  }

  checkConsent() {
    const activeGroups = this.context;
    console.log('activeGroups', activeGroups);
    if (activeGroups && Array.isArray(activeGroups)) {
      const load = this.groupsLoadGtm.some(id => activeGroups.includes(id));
      if (load && !window.dataLayer) {
        this.loadGTM();
      }

      // ... weitere loads...
    } else {
      console.log('oneTrustLoader: Warte auf Consent-Daten...');
    }
  }

  loadGTM() {
    console.log('loadGTM');
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',this.gtmId);
  }

  render() {
    return null;
  }
}

export default OneTrustLoader;
